var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconInfo = function SvgIconInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 .875a5.126 5.126 0 1 1-.001 10.251A5.126 5.126 0 0 1 6 .875zm.008 1.114-.152.003a3.992 3.992 0 0 0-2.675 1.19 3.981 3.981 0 0 0-.024 5.661 3.985 3.985 0 0 0 5.662-.025 3.985 3.985 0 0 0 .024-5.661A3.985 3.985 0 0 0 6.16 1.99l-.151-.002zM6 5.166c.388 0 .703.315.703.703v2.29a.703.703 0 0 1-1.406-.001V5.87c0-.388.315-.703.703-.703zm0-2.019a.82.82 0 1 1 0 1.64.82.82 0 0 1 0-1.64z",
    fill: "#292A2C",
    fillRule: "evenodd"
  })));
};
export default SvgIconInfo;